import { Box, Card } from '@mui/material';
import { useGetOne } from 'react-admin';
import { DataStats } from "../../models/data-stats";
import { DateRangePicker } from '../date-range-picker/date-range-picker';
import dayjs from 'dayjs';
import { MapAttributeSelect } from '../map-attribute-select/map-attribute-select';
import { ColorSchemeSelect } from '../color-scheme-select/color-scheme-select';
import { ColorValueRangeSlider } from '../color-value-range-slider/color-value-range-slider';
import { historicalPeriodMap } from '../../models/historical-period-map';
import { MapDataType } from '../../models/map-attribute';
import { ColorReverseCheck } from '../color-reverse-check/color-reverse-check';
import { ColorOpacitySlider } from '../color-opacity-slider/color-opacity-slider';

export const filterDefaultToDate = dayjs('2025-06-01').endOf('month');
export const filterDefaultPeriodId = 2;
export const filterDefaultFromDate = filterDefaultToDate.subtract(historicalPeriodMap[filterDefaultPeriodId].months, 'month');
export const filterDefaultMapAttribute = 'MedianSalePrice';

const Spacer = () => <span style={{ width: '2.5em' }} />;

export const GlobalMapFilter = ({ dataStats, mapDataType }: { dataStats?: DataStats; mapDataType: MapDataType }) => {

  const { data: mapAttributeData, } = useGetOne<any>('map-attribute', { id: mapDataType });
  const mapAttributeList = mapAttributeData?.mapAttributes ?? [];

  return (
    <Card sx={{ p: 2, marginTop: 2, width: '100%', height: 100 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', }} >
          <DateRangePicker 
            defaultToDate={filterDefaultToDate} 
            defaultFromDate={filterDefaultFromDate} 
            defaultPeriodId={filterDefaultPeriodId}             
            />
          <Spacer />
          <MapAttributeSelect mapAttributeList={mapAttributeList} defaultMapAttribute={filterDefaultMapAttribute}/>
          <Spacer />
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width: '100%', }} >
            <ColorValueRangeSlider
              min={dataStats?.dataMin ?? 0}
              max={dataStats?.dataMax ?? 0}
              disabled={dataStats === undefined}
            />
            <Spacer />
            <ColorSchemeSelect />
            <ColorReverseCheck />
            <ColorOpacitySlider />
          </Box>
        </Box>
      </Box>
    </Card>
  );
};
